{
    "commute_time_min": "commute buffer (minutes)",
    "ignored_patient_tags": "client tags to ignore",
    "match_patient_office": "limit to the client’s office",
    "match_patient_tags": "match client tags",
    "max_consecutive_days": "max days in a row",
    "max_contact_attempts_48h": "max contacts per 48 hours",
    "max_daily_hours": "daily hours cap",
    "max_distance_mi": "max travel distance (miles)",
    "max_weekly_hours": "weekly hours cap",
    "overtime_behavior": "caregivers over the weekly cap",
    "auto_send_all_replies": "auto-reply to everything",
    "auto_send_callout_decline_response": "auto-reply when a caregiver declines a callout",
    "auto_send_negative_shift_confirmation_replies": "auto-reply to shift declines",
    "auto_send_positive_shift_confirmation_replies": "auto-reply to shift confirmations",
    "auto_send_unclear_shift_confirmation_replies": "auto-reply to unclear responses",
    "axiscare_service_rate_selection_enabled": "AxisCare service rate selection",
    "callout_interest_reply_enabled": "send open-shift interest acknowledgement",
    "call_recording_notice_enabled": "play the call-recording notice",
    "clock_in_grace_minutes": "clock-in grace period (minutes)",
    "clock_out_grace_minutes": "clock-out grace period (minutes)",
    "clock_reminder_monitor_window_hours": "missed clock in/out EHR check window (hours)",
    "default_notify_interested_on_fill": "notify interested caregivers when filling (default)",
    "default_notify_non_responders_on_fill": "notify caregivers who haven’t responded when filling (default)",
    "display_caregiver_names_last_first": "show caregiver names as last, first",
    "duty_completion_grace_minutes": "care task completion grace period (minutes)",
    "enable_clock_reminders_in_test_mode": "send clock reminders in test mode",
    "engaged_caregiver_threshold": "engaged caregiver threshold (%)",
    "immediate_transfer_recording_notice_enabled": "play the notice before an immediate transfer",
    "inbound_voice_agent_enabled": "answer inbound calls",
    "inbound_voice_shift_cancellation_always_transfer": "connect phone call-outs to a scheduler",
    "inbound_voice_shift_cancellation_enabled": "let callers cancel shifts by phone",
    "inbound_voice_shift_cancellation_transfer_threshold_hours": "transfer a phone cancellation within this many hours of the shift",
    "inbound_voice_transfer_resistance_enabled": "try to resolve a call before transferring it",
    "inbound_voice_transfer_unknown_callers_enabled": "transfer callers who aren’t caregivers",
    "include_sms_body_in_email_notification": "include the text message in email notifications",
    "mark_acceptance_outreach_messages_as_read": "mark acceptances as read",
    "mark_decline_outreach_messages_as_read": "mark declines as read",
    "mark_positive_shift_confirmation_messages_as_read": "mark confirmations as read",
    "notify_only_assigned_coordinators": "notify only assigned coordinators",
    "plan_of_care_duties_sms_enabled": "text caregivers about missing care tasks",
    "plan_of_care_duty_monitoring_enabled": "check visits for recorded care tasks",
    "require_wellsky_caregiver_rate_to_fill": "require a WellSky caregiver rate to fill",
    "require_wellsky_client_rate_to_fill": "require a WellSky client rate to fill",
    "unresponsive_caregiver_threshold": "unresponsive caregiver threshold (%)",
    "allow_auto_assign": "allow auto-assign",
    "allow_custom": "allow a custom outreach response option",
    "auto_assign_first_responder_default": "auto-assign the first responder (default)",
    "auto_start_outreach_default": "auto-start outreaches (default)",
    "eligible_caregivers_rows_per_page": "eligible-caregiver list size",
    "response_requery_window_hours": "how long a caregiver’s last response stays fresh (hours)",
    "unfilled_alert_lead_minutes": "minutes before an open shift starts to alert that it is still unfilled",
    "skip_busy_caregivers": "skip caregivers already working",
    "enable_relative_dates": "use relative dates",
    "enabled": "shift confirmations",
    "skip_recurring_shift_confirmations": "skip repeat confirmations for recurring shifts",
    "no_response_wait_minutes": "wait after the final confirmation follow-up before reporting no response (minutes)",
    "caregiver_quiet_hours_windows": "caregiver quiet hours schedule",
    "client_quiet_hours_windows": "client quiet hours schedule",
    "allow_client_identifying_info": "allow client identifying info in texts",
    "unknown_caller_auto_transfer_enabled": "auto-transfer unknown callers",
    "sections": {
        "general_settings": "general organization settings",
        "callout_settings": "callout settings",
        "shift_confirmation_settings": "shift-confirmation settings",
        "care_plan_settings": "care-plan settings",
        "recommendation_defaults": "recommendation defaults"
    }
}
